import invariant from 'tiny-invariant'

interface ObjectItem {
  entityId: string
  userId: string
}

export const createObjectPath = (item: ObjectItem) => {
  const { userId, entityId } = item
  invariant(userId, 'User ID must be defined')
  invariant(entityId, 'Entity ID must be defined')
  return `users/${item.userId}/storage/${item.entityId}`
}

/** Debounce function for accumulating calls. All promises will resolve/reject to the last call's result */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debounceResolveAll = <T extends (...args: any[]) => any>(fn: T, delay: number) => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null
  let pendingResolvers: { resolve: (value: ReturnType<T>) => void; reject: (error: unknown) => void }[] = []

  return (...args: Parameters<T>) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    return new Promise<ReturnType<T>>((resolve, reject) => {
      pendingResolvers.push({ resolve, reject })

      timeoutId = setTimeout(() => {
        try {
          const result = fn(...args)
          pendingResolvers.forEach(({ resolve }) => resolve(result))
        } catch (error) {
          pendingResolvers.forEach(({ reject }) => reject(error))
        }
        pendingResolvers = []
      }, delay)
    })
  }
}
